import itemActions from "./itemActions";

const allActions = {
  itemActions,
};

export default allActions;
